import {IGameInfo, ILeague, IUser} from "@/entities/user/types";
import {IMemberTeam, MemberRole} from "@/entities/team/types";
import {IBet} from "@/entities/forecast/types";
import {IRatingList} from "@/entities/rating/types";
import {useCallback} from "react";


export const sortRating = (list: IRatingList[]) =>
    [...list].sort((a, b) => b.score - a.score);

export const glueName = (user: IUser | IMemberTeam | IBet) => {
    return user.firstName + ' ' + user.lastName
}

export const getLeague = (gameInfo: IGameInfo, league: ILeague[]): ILeague => {
    const find = league.find(item => gameInfo.user.score >= item.from && gameInfo.user.score <= item.to)
    if (!find) return league[0]
    return find
}

export const isCaptain = (userId: number, members: IMemberTeam[]): boolean | null => {
    const find = members.find(item => item.userId === userId)
    if (!find) return null
    return find.role == MemberRole.CAPTAIN
}
